import React from 'react';
import { Heading } from "../CMS/elements";

export const ITNPackagePage = () => {
    const isUS = localStorage.getItem( 'site_of_origin' ).toLowerCase() === 'us';

    return (
        <div className="expired-memberships">
            <div className="expired-memberships__background">
                <div className="container">
                    <div className="row">
                        <div className="expired-memberships__content content col-xs-12 col-md-offset-2 col-md-8">
                            <div className="content__header">
                                < Heading content="Your Membership has expired." size="h1" />
                            </div>
                            <div className="content__body">
                                <div className="kiwi-text">
                                    <p className="p-tag">Your In Touch membership has expired. You can no longer utilise our development tools or jobs board. To extend your membership please click <a href={ `${ isUS ? 'https://intouchnetworks.com/en-us/membership-packages' : 'https://join.intouchnetworks.com/renew-your-membership/' }` } target="_blank">here</a>.</p>
                                </div>
                            </div>
                            <a className="btn btn-primary" href={ `${ isUS ? 'https://intouchnetworks.com/en-us/membership-packages' : 'https://join.intouchnetworks.com/renew-your-membership/' }` } target="_blank">Renew your membership</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};



// WEBPACK FOOTER //
// src/client/components/common/purchases/ITNPackagePage.js